import * as React from "react";

// Import styles
import "./styles/servicesTabs.scss";

// Import icons
import {
  // Pre-Production icons
  FaBook,
  FaChess,
  FaMicroscope,
  FaCommentDollar,
  FaChalkboardTeacher,
  FaEdit,
  FaScroll,
  FaHardHat,
  FaStreetView,
  FaCalendarCheck,
  // Production icons
  FaClipboardList,
  FaFileSignature,
  FaUtensils,
  FaCropAlt,
  FaUsers,
  FaPalette,
  FaVideo,
  FaHeadset,
  FaLightbulb,
  FaVolumeUp,
  // Post-Production icons
  FaFilm,
  FaFileVideo,
  FaMusic,
  FaTint,
  FaEyeDropper,
  FaLaptop,
  FaUndo,
  FaFileExport,
  FaClosedCaptioning,
  FaArchive,
} from "react-icons/fa";

// Bootstrap imports
import { Container, Tab, Tabs } from "react-bootstrap";

const ForAgenciesTabs = (props) => {
  return (
    <Container className="services-tabs">
      <Tabs
        className="fade-in-slow"
        defaultActiveKey="pre-production"
        id="uncontrolled-tab-example"
      >
        <Tab
          className="fade-in-slow"
          eventKey="pre-production"
          title="Pre Production"
        >
          <div className="services-list">
            <div className="services-item">
              <FaBook />
              <h4 className="talk">Story Development</h4>
            </div>
            <div className="services-item">
              <FaChess />
              <h4 className="talk">Strategy</h4>
            </div>
            <div className="services-item">
              <FaMicroscope />
              <h4 className="talk">Research</h4>
            </div>
            <div className="services-item">
              <FaCommentDollar />
              <h4 className="talk">Budgeting</h4>
            </div>
            <div className="services-item">
              <FaChalkboardTeacher />
              <h4 className="talk">Pitching</h4>
            </div>
            <div className="services-item">
              <FaEdit />
              <h4 className="talk">Copywriting</h4>
            </div>
            <div className="services-item">
              <FaScroll />
              <h4 className="talk">Scripting</h4>
            </div>
            <div className="services-item">
              <FaHardHat />
              <h4 className="talk">Crewing</h4>
            </div>
            <div className="services-item">
              <FaStreetView />
              <h4 className="talk">Casting</h4>
            </div>
            <div className="services-item">
              <FaCalendarCheck />
              <h4 className="talk">Scheduling</h4>
            </div>
          </div>
        </Tab>
        <Tab className="fade-in-slow" eventKey="production" title="Production">
          <div className="services-list">
            <div className="services-item">
              <FaClipboardList />
              <h4 className="talk">Logistics</h4>
            </div>
            <div className="services-item">
              <FaFileSignature />
              <h4 className="talk">Release Forms</h4>
            </div>
            <div className="services-item">
              <FaUtensils />
              <h4 className="talk">Crafts Services</h4>
            </div>
            <div className="services-item">
              <FaCropAlt />
              <h4 className="talk">Directing</h4>
            </div>
            <div className="services-item">
              <FaUsers />
              <h4 className="talk">Crew Management</h4>
            </div>
            <div className="services-item">
              <FaPalette />
              <h4 className="talk">Production Design</h4>
            </div>
            <div className="services-item">
              <FaVideo />
              <h4 className="talk">Cinema Camera</h4>
            </div>
            <div className="services-item">
              <FaHeadset />
              <h4 className="talk">Grip Package</h4>
            </div>
            <div className="services-item">
              <FaLightbulb />
              <h4 className="talk">Lighting Package</h4>
            </div>
            <div className="services-item">
              <FaVolumeUp />
              <h4 className="talk">Audio Recording</h4>
            </div>
          </div>
        </Tab>
        <Tab
          className="fade-in-slow"
          eventKey="post-production"
          title="Post Production"
        >
          <div className="services-list">
            <div className="services-item">
              <FaFilm />
              <h4 className="talk">4k Editing</h4>
            </div>
            <div className="services-item">
              <FaFileVideo />
              <h4 className="talk">Motion Graphics</h4>
            </div>
            <div className="services-item">
              <FaMusic />
              <h4 className="talk">Music Licensing</h4>
            </div>
            <div className="services-item">
              <FaTint />
              <h4 className="talk">Color Correction</h4>
            </div>
            <div className="services-item">
              <FaEyeDropper />
              <h4 className="talk">Color Grading</h4>
            </div>
            <div className="services-item">
              <FaLaptop />
              <h4 className="talk">Online View</h4>
            </div>
            <div className="services-item">
              <FaUndo />
              <h4 className="talk">Client Revisions</h4>
            </div>
            <div className="services-item">
              <FaFileExport />
              <h4 className="talk">Transcoding</h4>
            </div>
            <div className="services-item">
              <FaClosedCaptioning />
              <h4 className="talk">Captions</h4>
            </div>
            <div className="services-item">
              <FaArchive />
              <h4 className="talk">Archival</h4>
            </div>
          </div>
        </Tab>
      </Tabs>
    </Container>
  );
};

export default ForAgenciesTabs;
